module.exports = __webpack_public_path__ + "img/Nikken.64e53502.jpg";